import { createContext } from 'react';

import { ProgramDashboard } from '@totem/components/services/optimize/v2/dashboard/types';

interface Context {
  buildingId: string;
  programId: string;
  dashboard: ProgramDashboard | null;
  loading: boolean;
  requestRefresh: () => void;
}

const defaultContext: Context = {
  buildingId: '',
  programId: '',
  dashboard: null,
  loading: false,
  requestRefresh: () => {},
};

const ProgramDashboardContext = createContext<Context>(defaultContext);

export default ProgramDashboardContext;
